/* eslint-disable no-console */
import { get } from 'lodash';
import pkg from '../../package.json';

import apiService from './ApiService';
import { HELPER } from '.';
const { mixpanelService } = apiService.getInstance();

const width = window.innerWidth;
const height = window.innerHeight;
const defaultParams = {
  'App Name': 'DANA',
  'Package Version': pkg.version,
  'Package Source': 'Online',
  'Current URL': window.location.href,
  'Screen Height': height / 2,
  'Screen Width': width / 2,
  Device: window.IS_ANDROID ? 'Android' : 'iPhone',
  OS: window.IS_ANDROID ? 'Android' : 'iOS',
};

const init = () => {
  try {
    const userId = HELPER.getUserId();

    mixpanelService.post('profile', {
      id: userId,
      properties: {
        'User ID': userId,
        'App Name': 'DANA',
        'Package Version': pkg.version,
        'Package Source': 'Online',
      },
    });
  } catch (err) {
    console.log(err);
  }
};

const trackEvent = (eventName, params, isWithServiceName = true) => (
  _dispatch,
  getState,
) => {
  try {
    const universalKeyword = formatUniversalKeyword(
      get(getState(), 'service.service.universal_keyword', 'ALL_BILLER'),
    );

    const mixpanelEventName = `${
      isWithServiceName ? universalKeyword : ''
    }${eventName}`;
    const userId = HELPER.getUserId();

    const paramEvent = {
      'User ID': userId,
      ...defaultParams,
      ...params,
    };

    mixpanelService.post('event', {
      profile_id: userId,
      event: {
        name: mixpanelEventName,
        timestamp: new Date().toISOString(),
        properties: paramEvent,
      },
    });
  } catch (err) {
    console.log(err);
  }
};

const formatUniversalKeyword = input => {
  const splittedText = input
    .split('_')
    .map(text => text.charAt(0).toUpperCase() + text.slice(1).toLowerCase());

  // E Commerce must be joined with '-'
  if (splittedText[0] === 'E') {
    return `${splittedText.join('-')} `;
  }
  return `${splittedText.join(' ')} `;
};

export { init, trackEvent, formatUniversalKeyword };
